<template>
  <div>
    <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isUpdateActive" position-right>
      <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
        <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-4 d-theme-dark-bg tranksaksi-header bg-primary">
          <div class="flex">
            <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="closeUpdateView" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
            <!--
            <h5 class="text-white">{{ Object.entries(this.data).length === 0 ? "New" : "View" }} {{barangName}}</h5>
            -->
          </div>
          <!--
          <div class="flex">
            <h4 class="text-white">Total {{ dataTotal | currency}}</h4>
          </div>
          -->
          
          <div class="ml-10 mt-1 flex items-center" v-if="Object.entries(this.data).length != 0">
            <template v-if="filter != 'trash'">
              <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <feather-icon icon="TagIcon" svg-classes="text-white h-7 w-7" class="cursor-pointer pt-1"></feather-icon>
                <vs-dropdown-menu style="z-index: 40001">
                  <vs-dropdown-item v-for="(label, index) in tags" :key="index" @click.stop>
                    <vs-checkbox :vs-value="label.slug" v-model="currentTag">{{ label.name }}</vs-checkbox>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-switch class="ml-4" color="dark" v-model="disabled" v-can="'E'"/>
              <vs-button class="ml-4" color="dark" size="small" icon-pack="feather" icon="icon-plus" v-on:click="openPembayaranSidebar()">Bayar</vs-button>
              <vs-button class="ml-4" color="danger" size="small" icon-pack="feather" icon="icon-trash" @click="hapusTranksaksiConfirm()" v-can="'D'">Trash</vs-button>
            </template>
            <template v-else>
              <vs-button class="ml-4" color="warning" size="small" icon-pack="feather" icon="icon-refresh-ccw" @click="restoreTranksaksiConfirm()" v-can="'D'">Restore</vs-button>
            </template>
          </div>
          
        </div>

        <component :is="scrollbarTag" class="tranksaksi-content-scroll-area md:px-12 pt-4 px-4 mt-base" :settings="settings" :key="$vs.rtl">
          <div class="vx-col w-full sm:w-full items-center sm:flex-row flex-col mx-auto">
            
            <div class="vx-row mb-4">
              <div class="vx-col w-1/3 flex justify-between">
                <vs-select
                  label="Supplier"
                  v-model="dataSupplier"
                  v-validate="'required'"
                  class="w-full"
                  :disabled="disabled"
                  @change="pilihSupplier"
                  @click.prevent="changePilihSupplier"
                  >
                    <vs-select-item value="0" text="Pilih"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSupplier"/>
                </vs-select>
                <!--
                <vs-button class="mt-6" @click.stop="openSupplierSidebar()" icon-pack="feather" icon="icon-plus"></vs-button>
                -->
              </div>
              <div class="vx-col w-1/3">
                <vs-input label="Telepon" v-model="dataSupplierTelepon" class="w-full" type="telepon" name="item-telepon" v-validate="'required|numeric'" :disabled="disabled"/>
                <span class="text-danger text-sm" v-show="errors.has('item-telepon')">{{ errors.first('item-telepon') }}</span>
              </div>
              <div class="vx-col w-1/3">
                <vs-input label="Email" v-model="dataSupplierEmail" class="w-full" type="email" name="item-email" v-validate="'required|email'" :disabled="disabled"/>
                <span class="text-danger text-sm" v-show="errors.has('item-email')">{{ errors.first('item-email') }}</span>
              </div>
            </div>
            
            <div class="vx-row mb-4">
              <div class="vx-col w-1/4">
                <span class="text-sm">Tanggal Tranksaksi</span>
                <datepicker placeholder="Select Date" v-model="dataTanggal" :disabled="disabled"></datepicker>
              </div>
              <div class="vx-col w-1/4">
                <span class="text-sm">Tanggal Tenggat</span>
                <datepicker placeholder="Select Date" v-model="dataTanggalTenggat" :disabled="disabled"></datepicker>
              </div>
              <div class="vx-col w-1/4">
                <vs-input label="Nomor Tranksaksi" v-model="dataNomor" class="w-full" name="item-nomor" v-validate="'required'" :disabled="disabled"/>
                <span class="text-danger text-sm" v-show="errors.has('item-nomor')">{{ errors.first('item-nomor') }}</span>
              </div>
              <div class="vx-col w-1/4">
                <vs-input label="Supplier Ref No." v-model="dataNomorSupplierRef" class="w-full" name="item-nomor" v-validate="'required'" :disabled="disabled"/>
                <span class="text-danger text-sm" v-show="errors.has('item-nomor')">{{ errors.first('item-nomor') }}</span>
              </div>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col w-1/2 flex justify-between">
                <vs-select
                  label="Syarat Bayar"
                  v-model="dataSyaratBayar"
                  v-validate="'required'"
                  class="w-full"
                  :disabled="disabled"
                  @click.prevent="changePilihSyaratBayar"
                  >
                    <vs-select-item value="0" text="Pilih"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSyaratBayar"/>
                </vs-select>
                <vs-button class="mt-6" @click.stop="openSyaratBayarSidebar()" icon-pack="feather" icon="icon-plus" :disabled="disabled"></vs-button>
              </div>
              <div class="vx-col w-1/2 flex justify-between">
                <vs-select
                  label="Gudang"
                  v-model="dataGudang"
                  v-validate="'required'"
                  class="w-full"
                  :disabled="disabled"
                  @click.prevent="changePilihGudang"
                  >
                    <vs-select-item value="0" text="Pilih"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listGudang"/>
                </vs-select>
                <vs-button class="mt-6" @click.stop="openGudangSidebar()" icon-pack="feather" icon="icon-plus" :disabled="disabled"></vs-button>
              </div>
            </div>
            
            <vs-divider class="mt-base">Barang Pembelian</vs-divider>
            
            <div v-for="(pembelian,indexpembelian) in rowPembelian" :key="`pembelian-${indexpembelian}`">
              <div class="vx-row">
                <div class="vx-col flex flex-1 justify-between">
                  <vs-select
                    label="Kategori"
                    v-model="pembelian.dataTaxonomy"
                    v-validate="'required'"
                    class="w-full"
                    :disabled="disabled"
                    @change="pilihPembelian(indexpembelian)"
                    @click.prevent="changePilihTaxonomy(indexpembelian)"
                    >
                      <vs-select-item value="0" text="Pilih"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listTaxonomy"/>
                  </vs-select>
                  <vs-button class="mt-6" @click.stop="openTaxonomySidebar()" icon-pack="feather" icon="icon-plus" :disabled="disabled"></vs-button>
                </div>
                <div class="vx-col flex flex-1 justify-between">
                  <vs-select
                    :id="`barang-${indexpembelian}`"
                    size="small"
                    label="Barang"
                    v-model="pembelian.dataBarang"
                    v-validate="'required'"
                    class="w-full vs-con-loading__container"
                    :disabled="disabled"
                    @change="pilihBarang(indexpembelian)"
                    @click.prevent="changePilihBarang(indexpembelian)"
                    autocomplete
                    >
                      <vs-select-item value="0" text="Pilih"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.name}`" v-for="itemx in pembelian.dataBarangList"/>
                  </vs-select>
                  <vs-button class="mt-6" @click.stop="openBarangSidebar(indexpembelian)" icon-pack="feather" icon="icon-plus" :disabled="disabled || pembelian.barangAddDisabled"></vs-button>
                </div>
                <div class="vx-col flex pt-6">
                  <vs-button color="danger" type="border" icon-pack="feather" icon="icon-trash" @click.prevent="deletePembelian(indexpembelian)" :disabled="disabled"></vs-button>
                </div>
              </div>
              <div class="vx-row mt-2">
                <div class="vx-col w-2/5 flex">
                  <vs-input 
                  :id="`harga-${indexpembelian}`"
                  label="Harga (Rp.)" 
                  v-model="pembelian.dataPrice" 
                  class="w-full jumlah" 
                  name="item-jumlah" 
                  v-validate="'required'" 
                  :disabled="disabled"
                  @input="updateJumlah(indexpembelian)" 
                  v-currency="{
                  currency: null, 
                  locale: 'de',
                  precision:0,
                  distractionFree:false
                  }"/>
                  <p class="pl-4 pt-8">{{pembelian.dataSatuan}}</p>
                  <span class="text-danger text-sm" v-show="errors.has(`harga-${indexpembelian}`)">{{ errors.first(`harga-${indexpembelian}`) }}</span>

                </div>
                <div class="vx-col w-2/5 flex items-center pt-6 justify-between">
                  <div>
                    <vs-input-number v-model="pembelian.dataQuantity" @input="updateJumlah(indexpembelian)" name="item-quantity" class="pl-2" :disabled="disabled"/>
                    <span class="text-danger text-sm" v-show="errors.has('item-quantity')">{{ errors.first('item-quantity') }}</span>
                  </div>
                  <h6>{{pembelian.dataJumlahSbPajak | currency}}</h6>
                </div>
                <div class="vx-col flex flex-1 justify-between">
                  <vs-select
                    label="Pajak"
                    v-model="pembelian.dataPajak"
                    v-validate="'required'"
                    class="w-full"
                    :disabled="disabled"
                    @change="pilihPajak(indexpembelian)"
                    @click.prevent="changePilihPajak(indexpembelian)"
                    >
                      <vs-select-item value="0" text="include / tidak kena pajak"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.name} ${itemx.nilai}%`" v-for="itemx in listPajak"/>
                  </vs-select>
                  <vs-button class="mt-6" @click.stop="openPajakSidebar()" icon-pack="feather" icon="icon-plus" :disabled="disabled"></vs-button>
                </div>
              </div>
              <vs-divider class="mt-base"></vs-divider>
            </div>
            
            <div class="vx-row mb-4">
              <div class="vx-col w-full flex justify-center">
                <vs-button @click="addPembelian" icon-pack="feather" icon="icon-plus" :disabled="disabled"></vs-button>
              </div>
            </div>

            <div class="vx-row mb-4 md:flex-row flex-col-reverse">
              <div class="vx-col md:w-3/5 lg:w-2/3 w-full mt-2">
                <vs-textarea label="Pesan" v-model="dataPesan" class="w-full" name="item-pesan" :disabled="disabled"/>

                <vs-textarea label="Memo" v-model="dataMemo" class="w-full" name="item-memo" :disabled="disabled"/>

                <div>
                  <template v-if="mobile == true">
                    <template v-if="Attachment" class="text-center">
                      <div class="img-container w-full">
                        <img :src="Attachment" class="responsive">
                        <vs-button class="" @click="cameraTakePicture" color="warning">Ulang Foto Attachment</vs-button>
                      </div>
                    </template>
                    <template v-else>
                      <vs-button class="w-full" @click="cameraTakePicture" color="warning">Ambil Foto Attachment</vs-button>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="Attachment">
                      <div class="img-container w-full" v-if="upImg">
                        <img :src="getImage('/tranksaksi/'+Attachment)" alt="" class="responsive" v-if="upImg">
                      </div>
                      <div class="img-container w-full">
                        <img :src="Attachment" alt="" class="responsive">
                      </div>
                      <div class="modify-img flex justify-between">
                        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                        <vs-button class="w-full" @click="$refs.updateImgInput.click();upImg = false" color="warning" :disabled="disabled">Update Attachment (Image)</vs-button>
                      </div>
                    </template>

                    <div class="upload-img" v-else>
                      <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
                      <vs-button class="w-full" @click="$refs.uploadImgInput.click();upImg = false" color="warning" :disabled="disabled">Upload Attachment (Image)</vs-button>
                    </div>
                  </template>
                </div>

              </div>

              <div class="vx-col md:w-2/5 lg:w-1/3 w-full mb-base">
                <div class="flex flex-wrap justify-between mt-3">
                  <h6>Sub Total</h6>
                  <h5>{{dataSubTotal | currency}}</h5>
                </div>
                <div class="flex flex-wrap justify-between mt-3">
                  <h6>Pajak</h6>
                  <h5>{{dataPajakTotal | currency}}</h5>
                </div>
                <div class="flex flex-wrap justify-between mt-3">
                  <h5>Total</h5>
                  <h5>{{dataTotalPU | currency}}</h5>
                </div>
                
                <div class="vx-row mt-3 flex items-center">
                  <div class="vx-col w-1/2 flex justify-between">
                    <h6 class="">Biaya Kirim</h6>
                  </div>
                  <div class="vx-col w-1/2 flex justify-end items-center">
                    <vs-input 
                      class="w-full jumlah"
                      v-model="dataBiayaKirim" 
                      v-validate="''" 
                      :disabled="disabled"
                      v-currency="{
                      currency: null, 
                      locale: 'de',
                      precision:0,
                      distractionFree:false
                      }"
                      @input="eventTotal()" 
                    />
                  </div>
                </div>
                
                <div class="vx-row mt-3 flex items-center">
                  <div class="vx-col w-1/2 flex justify-between">
                    <h6 class="">Biaya Lain-lain</h6>
                  </div>
                  <div class="vx-col w-1/2 flex justify-end items-center">
                    <vs-input 
                      class="w-full jumlah"
                      v-model="dataBiayaLainlain" 
                      v-validate="''" 
                      :disabled="disabled"
                      v-currency="{
                      currency: null, 
                      locale: 'de',
                      precision:0,
                      distractionFree:false
                      }"
                      @input="eventTotal()" 
                    />
                  </div>
                </div>
                
                <div class="vx-row mt-3 flex items-center">
                  <div class="vx-col w-2/3 flex justify-between">
                    <h6 class="">Potongan</h6>
                    <vs-switch v-model="dataPotongan"  :disabled="disabled"/>
                  </div>
                  <div class="vx-col w-1/3 flex justify-end items-center">
                    <vs-input 
                      class="w-full jumlah pr-2"
                      v-model="dataPotonganPersen" 
                      v-validate="''" 
                      :disabled="!dataPotongan || disabled"
                      v-currency="{
                      currency: null, 
                      locale: 'de',
                      precision:0,
                      distractionFree:false
                      }"
                      @input="updatePotongan()" 
                    />
                    <h4>%</h4>
                  </div>
                </div>
                
                <!--
                <div class="flex flex-wrap justify-between mt-3">
                  <h6>Potongan</h6>
                  <vs-switch v-model="dataPotongan" />
                  <vs-input 
                  size=""
                  class="jumlah"
                  v-model="dataPotonganJumlah" 
                  v-validate="'required'" 
                  :disabled="!dataPotongan"/>
                </div>
                -->
                <div class="flex flex-wrap justify-between mt-3">
                  <div class="vx-col w-1/2 flex justify-between">
                    <h6>Jumlah Potongan</h6>
                  </div>
                  <div class="vx-col w-1/2 flex justify-between">
                    <vs-input 
                      class="jumlah pr-2"
                      v-model="dataPotonganJumlah" 
                      v-validate="''" 
                      :disabled="!dataPotongan || disabled"
                      v-currency="{
                      currency: null, 
                      locale: 'de',
                      precision:0,
                      distractionFree:false
                      }"
                      @input="updatePotonganJumlah()" 
                    />
                  </div>
                  <!--
                  <h5>{{dataPotonganJumlah | currency}}</h5>
                  -->
                </div>

                <div class="vx-row mt-3 flex items-center">
                  <div class="vx-col w-1/2">
                    <h6>Pembayaran</h6>
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-select
                      class="w-full"
                      size="small"
                      v-model="dataPembayaran"
                      v-validate="'required'"
                      @click.prevent="changePilihPembayaran"
                      :disabled="disabled"
                      >
                        <vs-select-item :key="itemx.value" :value="itemx.value" :text="itemx.text" v-for="itemx in dataPembayaranList"/>
                    </vs-select>
                  </div>

                </div>

                <div class="vx-row mt-1 flex items-center">
                  <div class="vx-col w-1/2">
                    <vs-select
                      label="Dari kas"
                      v-model="dataAkunKas"
                      v-validate="'required'"
                      class="w-full"
                      :disabled="dataPembayaran === 'modal-tuan' || dataPembayaran === 'modal-saham' || dataPembayaran === 'hutang-pembelian' || disabled"
                      @change="updateUangMuka()"
                      @click.prevent="changePilihAkunKas"
                      >
                        <vs-select-item value="0" text="Pilih"/>
                        <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listAkun"/>
                    </vs-select>
                  </div>
                  
                  <div class="vx-col w-1/2">
                    <vs-input 
                      label="Jumlah"
                      class="w-full jumlah"
                      v-model="dataPembayaranJumlah" 
                      v-validate="'required'" 
                      :disabled="dataPembayaran != 'uang-muka-pembelian' || disabled"
                      @input="updateUangMuka()"
                      v-currency="{
                      currency: null, 
                      locale: 'de',
                      precision:0,
                      distractionFree:false
                      }"
                    />
                  </div>
                </div>

                <div class="flex flex-wrap justify-between mt-6">
                  <h5>Tagihan</h5>
                  <h4>{{dataTotal | currency}}</h4>
                </div>

              </div>
            </div>

            <vs-divider class="mt-8"></vs-divider>

            <div class="vx-row" v-if="!disabled">
              <div class="vx-col w-1/2">
                <vs-button type="border" color="danger" @click="closeUpdateView">Cancel</vs-button>
              </div>
              <div class="vx-col w-1/2 flex justify-end">
                <vs-button class="mr-4 mb-2" :disabled="!isFormValid" @click="submitData" color="primary">Submit</vs-button>
              </div>
            </div>
          </div>
        </component>
      </div>

      <vs-prompt
        color="danger"
        title="Konfirmasi"
        @accept="hapusTranksaksiAccept"
        :active.sync="hapusTranksaksi">
        <div class="con-exemple-prompt">
          Yakin ingin menghapus tranksaksi pembelian {{ dataTitle }}
        </div>
      </vs-prompt>

      <vs-prompt
        color="warning"
        title="Konfirmasi"
        @accept="restoreTranksaksiAccept"
        :active.sync="restoreTranksaksi">
        <div class="con-exemple-prompt">
          Yakin ingin me-restore tranksaksi pembelian {{ dataTitle }}
        </div>
      </vs-prompt>

      <taxonomy :isTaxonomyActive="isTaxonomyActive" @closeTaxonomy="closeTaxonomySidebar" :taxonomy="taxonomy"></taxonomy>
      <gudang :isGudangActive="isGudangActive" @closeGudang="closeGudangSidebar"></gudang>
      <syaratbayar :isSyaratBayarActive="isSyaratBayarActive" @closeSyaratBayar="closeSyaratBayarSidebar"></syaratbayar>
      <barang :isBarangActive="isBarangActive" @closeBarang="closeBarangSidebar" :Taxonomy="taxonomyBarang" :Tranksaksi="taxonomy"></barang>
      <pajak :isPajakActive="isPajakActive" @closePajak="closePajakSidebar"></pajak>
      <supplier :isSupplierActive="isSupplierActive" @closeSupplier="closeSupplierSidebar"></supplier>
      <pembayaran :isPembayaranActive="isPembayaranActive" @closePembayaran="closePembayaranSidebar" :data="data" tranksaksi="pembelian"></pembayaran>
    </vs-sidebar>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import themeConfig from "@/../themeConfig.js"
import { CurrencyDirective } from 'vue-currency-input'
import Gudang from '../term/Gudang.vue'
import Syaratbayar from '../term/SyaratBayar.vue'
import Taxonomy from '../term/Taxonomy.vue'
import Barang from '../term/Barang.vue'
import Pajak from '../term/Pajak.vue'
import Supplier from '../term/Supplier.vue'
import Pembayaran from '../term/Pembayaran.vue'
import moduleTaxonomy from '@/stores/term/taxonomy.js'
import moduleGudang from '@/stores/term/gudang.js'
import moduleSyaratBayar from '@/stores/term/syaratbayar.js'
import moduleBarang from '@/stores/term/barang.js'
import modulePajak from '@/stores/term/pajak.js'
import moduleAkun from '@/stores/term/akun.js'
export default{
  props: {
    isUpdateActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    tags: {
      type: Array,
      required: true
    },
    kategori: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      // Set
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.50
        },
        disabled: false,
        taxonomy: 'pembelian',

      // Mobile
        opti: {
          correctOrientation: true
        },

      barangName: null,

      // Sidebar
      isTaxonomyActive: false,
      isGudangActive: false,
      isSyaratBayarActive: false,
      isBarangActive: false,
      taxonomyBarang: '',
      isPajakActive: false,
      isSupplierActive: false,
      isPembayaranActive   : false,
      

      // Init
        dataTitle: null,
        dataUnit: 0,
        dataPrice: 0,
        dataQuantity: 0,

        dataLatitude: 0,
        dataLongitude: 0,

        dataParent: 0,
        dataTasksID: 0,
        changeSupplier: false,
        dataSupplier: 0,
        dataSupplierTitle: null,
        dataSupplierTelepon: null,
        dataSupplierEmail: null,

        dataPesan: null,
        dataMemo: null,
        Attachment : null,
        upImg: true,

        dataNomor: null,
        dataNomorSupplierRef: null,
        dataTanggal: new Date(),
        dataTanggalTenggat: new Date(),
        dataGudang: 0,
        changeGudang: false,
        dataSyaratBayar: 0,
        changeSyaratBayar: false,
        
        changePembelian: false,
        indexList : null,
        rowPembelian: [
          {
            dataTaxonomy: 0,
            slugTaxonomy: '',
            changeTaxonomy: false,
            barangAddDisabled: false,
            dataBarangList: [],
            dataBarang: 0,
            changeBarang: false,
            dataBarangNama: null,
            dataUnit : 0,
            dataSatuan : null,
            dataPrice: 0,
            dataQuantity : 1,
            dataPajak: 0,
            changePajak: false,
            dataJumlahSbPajak: 0,
            dataJumlahPajak: 0,
            dataJumlah : 0
          }
        ],
        dataSubTotal: 0,
        dataPajakTotal: 0,
        dataTotalPU: 0,

        dataBiayaKirim: 0,
        dataBiayaLainlain: 0,

        dataPotongan: false,
        dataPotonganPersen: 0,
        dataPotonganJumlah: 0,

        dataPembayaranJumlah: 0,
        dataPembayaran: 'hutang-pembelian',
        changePembayaran: false,
        dataPembayaranList: [
          {value:'hutang-pembelian', text:'Hutang Pembelian'},
          {value:'modal-tuan', text:'Modal Tuan'},
          {value:'modal-saham', text:'Modal Saham'},
          {value:'uang-muka-pembelian', text:'Uang Muka Pembelian'},
          {value:'lunas', text:'Lunas'}
        ],
        dataAkunKas: 0,
        changeAkunKas: false,
        dataTotal: 0,
      
      hapusTranksaksi: false,
      restoreTranksaksi: false
    }
  },
  components: {
    Datepicker,
    VuePerfectScrollbar,
    Gudang,
    Syaratbayar,
    Barang,
    Pajak,
    Supplier,
    Taxonomy,
    Pembayaran
  },
  directives: {
    currency: CurrencyDirective
  },
  watch: {
    isUpdateActive (value) {
      if (value) {
        if (this.kategori != 0) {
          const kat = this.$store.state.pembelian.tranksaksiKategoris.find((kategori) => kategori.id == this.kategori)
          this.kategoriName = kat.name
          if (Object.entries(this.data).length == 0) {
            this.disabled = false
            if (themeConfig.mobileMode == true) {
              navigator.geolocation.getCurrentPosition(this.loadLatLng  , this.mapError, { enableHighAccuracy: true });
            }
            this.initValues()
            this.$validator.reset()
          } else {
            this.$vs.loading({
              background: this.backgroundLoading,
              color: this.colorLoading,
              container: '#pembelian-load',
              type: 'sound',
              scale: 0.45
            })
            this.disabled = true
            const { id, task_title, task_unit, task_price, task_quantity, task_total, task_parent, task_sub_type, thumbnail, supplier, email_supplier, telepon_supplier, pesan, memo, tanggal, tanggal_tenggat, nomor, nomor_supplier, gudang, syaratbayar, potongan, potonganpersen,pembayaran, latitude, longitude, tasks_id } = JSON.parse(JSON.stringify(this.data))

            //biayakirim, biayalainlain, potonganjumlah, pembayaranjumlah, subtotal, pajak, akunkas, pembayaran_list

            this.dataTitle = task_title
            this.dataUnit = task_unit
            let euroGerman = Intl.NumberFormat("de-DE");
            this.dataPrice = euroGerman.format(task_price);
            this.dataQuantity = task_quantity
            this.dataTotal = task_total
            
            this.dataLatitude = latitude
            this.dataLongitude = longitude

            if (task_parent != 0) {
              this.dataParent = task_parent
            } else {
              this.dataParent = id
            }
            this.dataTasksID = tasks_id
            
            this.dataSupplier = supplier
            this.dataSupplierTitle = task_title
            this.dataSupplierTelepon = telepon_supplier
            this.dataSupplierEmail = email_supplier
            this.dataPesan = pesan
            this.dataMemo = memo
            this.Attachment = thumbnail

            this.dataNomor = nomor
            this.dataNomorSupplierRef = nomor_supplier
            this.dataTanggal = tanggal
            this.dataTanggalTenggat = tanggal_tenggat
            this.dataGudang = gudang
            this.dataSyaratBayar = syaratbayar
            //this.dataSubTotal = parseFloat(subtotal)
            //this.dataPajakTotal = parseFloat(pajak)
            //this.dataTotalPU = parseFloat(subtotal) + parseFloat(pajak)
            //this.dataBiayaKirim = this.formatUang(biayakirim)
            //this.dataBiayaLainlain = this.formatUang(biayalainlain)
            this.dataPotongan = potongan
            this.dataPotonganPersen = potonganpersen
            //this.dataPotonganJumlah = this.formatUang(potonganjumlah)
            //this.dataPembayaranJumlah = this.formatUang(pembayaranjumlah)

            //this.dataAkunKas = akunkas
            let url = null
            if (this.filter != 'trash') {
              url = 'tranksaksi-item'
            } else {
              url = 'tranksaksi-item-trash'
            }
            let configs = {
              headers: {
                'Authorization': 'Bearer ' + this.user.api_token
              }
            }
            this.axios.get('/'+url+'/'+tasks_id+'/'+task_sub_type, configs)
            .then((response) => {
              this.rowPembelian = []
              this.barang = response.data.data
              for (const element of this.barang) {
                if (element.task_sub_type === 'kas-bank') {
                  //this.dataPembayaran = 'lunas'
                  this.dataAkunKas = element.task_name
                  this.changeAkunKas = true
                } 
                else if (element.task_sub_type === 'biaya-kirim') {
                  this.dataBiayaKirim = this.formatUang(element.task_total)
                } 
                else if (element.task_sub_type === 'biaya-lainnya') {
                  this.dataBiayaLainlain = this.formatUang(element.task_total)
                } 
                else if (element.task_sub_type === 'potongan-pembelian') {
                  this.dataPotonganJumlah = this.formatUang(element.task_total)
                } 
                else if (element.task_sub_type === 'uang-muka-pembelian') {
                  this.dataPembayaranJumlah = this.formatUang(element.task_total)
                  //this.dataPembayaran = element.task_sub_type
                } 
                else if (element.task_sub_type === 'hutang-pembelian') {
                  this.dataPembayaran = element.task_sub_type
                } 
                else if (element.task_sub_type === 'modal-tuan') {
                  this.dataPembayaran = element.task_sub_type
                } 
                else if (element.task_sub_type === 'modal-saham') {
                  this.dataPembayaran = element.task_sub_type
                } 
                else {
                  this.rowPembelian.push({
                    dataTaxonomy: element.taxonomy_id,
                    slugTaxonomy: element.task_sub_type,
                    barangAddDisabled: false,
                    changeTaxonomy: false,
                    dataBarangList: element.list_barang,
                    dataBarang: element.task_name,
                    changeBarang: false,
                    dataBarangNama: element.task_title,
                    dataUnit : element.task_unit,
                    dataPrice: this.formatUang(element.task_price),
                    dataQuantity : element.task_quantity,
                    dataPajak: element.pajak,
                    changePajak: false,
                    dataJumlahSbPajak: element.task_quantity * element.task_price,
                    dataJumlahPajak: element.pajak_jumlah,
                    dataJumlah : element.task_total
                  });
                }
              }
              this.eventSubTotal()
              this.$vs.loading.close('#pembelian-load > .con-vs-loading')
            })
            .catch((error) => {
              this.$vs.loading.close('#pembelian-load > .con-vs-loading')
              this.$vs.notify({
                title: 'Error',
                text: error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })

            //this.$store.commit('pembelian/SET_PEMBAYARAN', pembayaran_list)
            this.dataPembayaran = pembayaran
          }
        } else { this.closeKatUpdateView() }
      } else { return }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
    isFormValid () { 
      let biayakirim = null
      if (this.dataBiayaKirim != 0) {
        biayakirim = this.dataBiayaKirim.split('.').join("")
      } else {
        biayakirim = this.dataBiayaKirim
      }
      let biayalainlain = null
      if (this.dataBiayaLainlain != 0) {
        biayalainlain = this.dataBiayaLainlain.split('.').join("")
      } else {
        biayalainlain = this.dataBiayaLainlain
      }

      return !this.errors.any() && !this.disabled && 
      this.dataSupplier != 0 && 
      this.dataSupplierTitle && 
      this.dataSupplierTelepon && 
      this.dataSupplierEmail && 
      
      this.Attachment && 

      this.dataNomor && 
      this.dataNomorSupplierRef && 
      this.dataTanggal && 
      this.dataTanggalTenggat && 
      this.dataGudang != null && 
      this.dataSyaratBayar != 0 && 
      
      this.rowPembelian.length >= 1 && 
      this.dataSubTotal != 0 && 
      this.dataPajakTotal != null && 
      this.dataTotalPU != 0 && 

      biayakirim != null && 
      biayalainlain != null && 
      
      this.dataPotonganPersen != null && 
      this.dataPotonganJumlah != null && 

      this.dataPembayaranJumlah != null && 
      //this.dataAkunKas != 0 && 

      this.dataTotal != 0
    },
    mobile () {
      return themeConfig.mobileMode
    },
    filter () {
      return this.$route.params.filter
    },
    listSupplier () {
      return this.$store.state.supplier.kontaks
    },
    currentTag: {
      get () {
        return this.data.tags
      },
      set (value) {
        if (Array.isArray(value)) {
          const payload = { id: this.data.id, tags: value, taxonomy:'tag-pembelian' }
          this.$store.dispatch('pembelian/setTag', payload)
        }
      }
    },
    listGudang () {
      return this.$store.state.gudang.gudangs
    },
    listSyaratBayar () {
      return this.$store.state.syaratbayar.syaratbayars
    },
    /*
    listTaxonomy () {
      return this.$store.state.taxonomy.taxonomies
    },
    */
    listTaxonomy () {
      return this.$store.state.akun.akuntaxonomy
    },
    listBarang () {
      return this.$store.state.barang.barangs
    },
    listPajak () {
      return this.$store.state.pajak.pajaks
    },
    listAkun () {
      return this.$store.state.akun.akungroups
    }
  },
  created () {
    this.$store.registerModule('gudang', moduleGudang)
    this.$store.registerModule('syaratbayar', moduleSyaratBayar)
    this.$store.registerModule('taxonomy', moduleTaxonomy)
    this.$store.registerModule('akun', moduleAkun)
    this.$store.registerModule('barang', moduleBarang)
    this.$store.registerModule('pajak', modulePajak)
    this.$store.dispatch('gudang/fetchGudang')
    this.$store.dispatch('syaratbayar/fetchSyaratBayar')
    this.$store.dispatch('taxonomy/fetchTaxonomy', 'pembelian')
    this.$store.dispatch('pajak/fetchPajak')
    this.$store.dispatch('akun/fetchAkunTaxonomy', this.taxonomy)
    this.$store.dispatch('akun/fetchAkunGroup', 'kas-bank')
    if (themeConfig.mobileMode == true) {
      navigator.geolocation.getCurrentPosition(this.mapOnePosition, this.mapOneError, { enableHighAccuracy: true });
    }
  },
  beforeDestroy () {
    this.$store.unregisterModule('gudang')
    this.$store.unregisterModule('taxonomy')
    this.$store.unregisterModule('pajak')
    this.$store.unregisterModule('barang')
    this.$store.unregisterModule('akun')
  },
  methods: {
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()

          let formData = new FormData()
          formData.set('task_title', this.dataSupplierTitle)
          formData.set('task_price', this.dataTotal)
          formData.set('task_quantity', '1')
          formData.set('task_total', this.dataTotal)
          formData.set('task_parent', this.dataParent)
          formData.set('tasks_id', this.dataTasksID)
          formData.set('task_sub_type', this.taxonomy)
          formData.set('task_group', 'null')
          formData.set('comment_status', 'null')
          formData.set('task_password', 'null')
          formData.set('pembelian', JSON.stringify(this.rowPembelian))

          formData.set('attachment_upload', this.upImg)
          if (this.upImg == false) {
            formData.append('attachment_file', this.Attachment)
          } else {
            formData.set('attachment_file', this.Attachment)
          }
          
          let meta = {
            supplier: this.dataSupplier,
            email_supplier: this.dataSupplierEmail,
            telepon_supplier: this.dataSupplierTelepon,
            pesan: this.dataPesan,
            memo: this.dataMemo,
            tanggal: this.formatDate(this.dataTanggal),
            tanggal_tenggat: this.formatDate(this.dataTanggalTenggat),
            nomor: this.dataNomor,
            nomor_supplier: this.dataNomorSupplierRef,
            gudang: this.dataGudang,
            syaratbayar: this.dataSyaratBayar,

            //biayakirim: biayakirim,
            //biayalainlain: biayalainlain,

            potongan: this.dataPotongan,
            potonganpersen: this.dataPotonganPersen,
            //potonganjumlah: potonganjumlah,

            latitude: this.dataLatitude,
            longitude: this.dataLongitude,
            
            pembayaran: this.dataPembayaran

            //akunkas: this.dataAkunKas
          }
          formData.set('meta', JSON.stringify(meta))

          // RELATIONSHIPS
          let relation_kategori =  {
            'kategori-pembelian': this.kategori
          }
          formData.set('relation_kategori', JSON.stringify(relation_kategori))

          let biayakirim = 0
          if (this.dataBiayaKirim != 0) {
            biayakirim = this.dataBiayaKirim.split('.').join("")
          }
          let biayalainlain = 0
          if (this.dataBiayaLainlain != 0) {
            biayalainlain = this.dataBiayaLainlain.split('.').join("")
          }
          let pembayaranjumlah = 0
          if (this.dataPembayaranJumlah != 0) {
            pembayaranjumlah = this.dataPembayaranJumlah.split('.').join("")
          } else {
            pembayaranjumlah = this.dataPembayaranJumlah
          }
          let potonganjumlah = 0
          if (this.dataPotonganJumlah != 0) {
            potonganjumlah = this.dataPotonganJumlah.split('.').join("")
          } else {
            potonganjumlah = this.dataPotonganJumlah
          }

          formData.set('gudang', this.dataGudang)
          formData.set('pembayaran', this.dataPembayaran)
          formData.set('akunkas', this.dataAkunKas)
          formData.set('supplier', this.dataSupplier)
          formData.set('pembayaranjumlah', pembayaranjumlah)
          formData.set('biayakirim', biayakirim)
          formData.set('biayalainlain', biayalainlain)
          formData.set('potonganjumlah', potonganjumlah)

          if (this.dataParent == 0) {
            formData.set('task_type', 'tranksaksi')
            formData.set('task_status', 'publish')
            this.$store.dispatch('pembelian/addUpdate', formData)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.closeUpdateView()
              this.initValues()
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          } else {
            formData.set('task_type', 'revision')
            formData.set('task_status', 'inherit')
            this.$store.dispatch('pembelian/editUpdate', formData)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.closeUpdateView()
              this.initValues()
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
        }
      })
    },
    hapusTranksaksiConfirm () {
      this.hapusTranksaksi = true
    },
    hapusTranksaksiAccept () {
      if (Object.entries(this.data).length > 0) {
        this.$vs.loading()
        this.$store.dispatch('pembelian/removeTranksaksi', this.data)
        .then((response) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Berhasil',
            color  : 'success',
            text  : response.message,
          })
          this.initValues()
          this.closeUpdateView()
          this.initValues()
        })
      }
      this.hapusTranksaksi = false
    },
    restoreTranksaksiConfirm () {
      this.restoreTranksaksi = true
    },
    restoreTranksaksiAccept () {
      if (Object.entries(this.data).length > 0) {
        this.$vs.loading()
        this.$store.dispatch('pembelian/restoreTranksaksi', this.data)
        .then((response) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Berhasil',
            color  : 'success',
            text  : response.message,
          })
          this.initValues()
          this.closeUpdateView()
          this.initValues()
        })
      }
      this.restoreTranksaksi = false
    },
    formatUang(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    initValues() {
      this.dataLatitude = 0
      this.dataLongitude = 0

      this.dataParent = 0
      this.dataTasksID = 0
      this.changeSupplier = false
      this.dataSupplier = 0
      this.dataSupplierTitle = null
      this.dataSupplierEmail = null
      this.dataSupplierTelepon = null

      this.dataPesan = null
      this.dataMemo = null
      this.Attachment = null
      this.upImg = true

      this.dataNomor = null
      this.dataNomorSupplierRef = null
      this.dataTanggal = new Date()
      this.dataTanggalTenggat = new Date()
      this.dataGudang = 0
      this.changeGudang = false
      this.dataSyaratBayar = 0
      this.changeSyaratBayar = false
      
      this.changePembelian = false
      this.indexList = null
      this.rowPembelian = [
        {
          dataTaxonomy: 0,
          slugTaxonomy: '',
          changeTaxonomy: false,
          barangAddDisabled: false,
          dataBarangList: [],
          dataBarang: 0,
          changeBarang: false,
          dataBarangNama: null,
          dataUnit : 0,
          dataSatuan : null,
          dataPrice: 0,
          dataQuantity : 1,
          dataPajak: 0,
          changePajak: false,
          dataJumlahSbPajak: 0,
          dataJumlahPajak: 0,
          dataJumlah : 0
        }
      ]
      this.dataSubTotal = 0
      this.dataPajakTotal = 0
      this.dataTotalPU = 0

      this.dataBiayaKirim = 0
      this.dataBiayaLainlain = 0

      this.dataPotongan = false
      this.dataPotonganPersen = 0
      this.dataPotonganJumlah = 0

      this.dataPembayaranJumlah = 0
      this.dataPembayaran = 'hutang-pembelian'
      this.changePembayaran = false
      this.dataPembayaranList = [
        {value:'hutang-pembelian', text:'Hutang Pembelian'},
        {value:'modal-tuan', text:'Modal Tuan'},
        {value:'modal-saham', text:'Modal Saham'},
        {value:'uang-muka-pembelian', text:'Uang Muka Pembelian'},
        {value:'lunas', text:'Lunas'}
      ]
      this.dataAkunKas = 0
      this.changeAkunKas = false
      this.dataTotal = 0
      this.hapusTranksaksi = false
      this.restoreTranksaksi = false

      this.disabled = false 
    },
    openPembayaranSidebar() {
      this.isPembayaranActive = true
    },
    closePembayaranSidebar () {
      this.isPembayaranActive = false
    },
    openTaxonomySidebar() {
      this.isTaxonomyActive = true
    },
    closeTaxonomySidebar () {
      this.isTaxonomyActive = false
    },
    openGudangSidebar() {
      this.isGudangActive = true
    },
    closeGudangSidebar () {
      this.isGudangActive = false
    },
    openSyaratBayarSidebar() {
      this.isSyaratBayarActive = true
    },
    closeSyaratBayarSidebar () {
      this.isSyaratBayarActive = false
    },
    openBarangSidebar(indexpembelian) {
      this.isBarangActive = true
      this.indexList = indexpembelian
      this.taxonomyBarang = this.rowPembelian[indexpembelian].slugTaxonomy
    },
    closeBarangSidebar () {
      this.isBarangActive = false
      this.rowPembelian[this.indexList].changeTaxonomy = true
      this.pilihPembelian(this.indexList)
    },
    openPajakSidebar() {
      this.isPajakActive = true
    },
    closePajakSidebar () {
      this.isPajakActive = false
    },
    openSupplierSidebar() {
      this.isSupplierActive = true
    },
    closeSupplierSidebar () {
      this.isSupplierActive = false
    },
    changePilihSupplier () {
      this.changeSupplier = true
    },
    pilihSupplier() {
      if (this.changeSupplier) {
        const ItemIndex = this.listSupplier.find((supplier) => supplier.id == this.dataSupplier)
        this.dataSupplierTitle = ItemIndex.name
        this.dataSupplierEmail = ItemIndex.email
        this.dataSupplierTelepon = ItemIndex.telepon
      }
    },
    changePilihGudang () {
      this.changeGudang = true
    },
    changePilihSyaratBayar () {
      this.changeSyaratBayar = true
    },
    changePilihTaxonomy (indexpembelian) {
      this.rowPembelian[indexpembelian].changeTaxonomy = true
    },
    changePilihBarang (indexpembelian) {
      this.rowPembelian[indexpembelian].changeBarang = true
    },
    changePilihPajak (indexpembelian) {
      this.rowPembelian[indexpembelian].changePajak = true
    },
    changeAddPembelian () {
      this.changePembelian = true
    },
    pilihPembelian(indexpembelian) {
      if (this.rowPembelian[indexpembelian].changeTaxonomy) {
        if (this.rowPembelian[indexpembelian].dataTaxonomy != 0) {
          this.rowPembelian[indexpembelian].changeTaxonomy = false
          this.rowPembelian[indexpembelian].dataBarang = 0
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#barang-'+indexpembelian,
            type: 'default',
            scale: 0.4
          })
          const ItemIndex = this.listTaxonomy.find((taxo) => taxo.id == this.rowPembelian[indexpembelian].dataTaxonomy)
          this.$store.commit('barang/SET_NULL')
          this.$store.dispatch('barang/fetchBarang', ItemIndex.slug)
          this.rowPembelian[indexpembelian].slugTaxonomy = ItemIndex.slug
          if (ItemIndex.slug === 'bahan-bangunan' || ItemIndex.slug === 'alat') {
            this.rowPembelian[indexpembelian].barangAddDisabled = true
          } else {
            this.rowPembelian[indexpembelian].barangAddDisabled = false
          }

          let configs = {
            headers: {
              'Authorization': 'Bearer ' + this.user.api_token
            }
          }
          this.axios.get('/term-list-sort/'+ItemIndex.slug+'/ASC', configs)
          .then((response) => {
            this.rowPembelian[indexpembelian].dataBarangList = response.data.data
          })
          .catch((error) => {
            this.$vs.notify({
              title: 'Error',
              text: error,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })

          if (this.$store.state.taxonomy.barangs.length > 0 || this.$store.state.taxonomy.barangs.length == 0) {
            // = this.$store.state.barang.barangs
            setTimeout(() => {
            this.$vs.loading.close('#barang-'+indexpembelian+' > .con-vs-loading')
            }, 3000)
          }
        } else {
          this.rowPembelian[indexpembelian].dataBarang = 0
          this.$store.commit('barang/SET_NULL')
        }
      }
    },
    pilihBarang(indexpembelian) {
      if (this.rowPembelian[indexpembelian].changeBarang) {
        if (this.rowPembelian[indexpembelian].dataBarang != 0) {
          this.rowPembelian[indexpembelian].changeBarang = false
          let ItemIndex = {}
          if (Object.entries(this.data).length == 0) {
            ItemIndex = this.listBarang.find((barang) => barang.id == this.rowPembelian[indexpembelian].dataBarang)
          } else {
            ItemIndex = this.rowPembelian[indexpembelian].dataBarangList.find((barang) => barang.id == this.rowPembelian[indexpembelian].dataBarang)
          }
          this.rowPembelian[indexpembelian].dataBarangNama = ItemIndex.name
          if (this.rowPembelian[indexpembelian].slugTaxonomy != 'bahan-bangunan') {
            this.rowPembelian[indexpembelian].dataPrice = this.formatUang(ItemIndex.harga)
            this.rowPembelian[indexpembelian].dataJumlahSbPajak = ItemIndex.harga
            this.rowPembelian[indexpembelian].dataUnit = ItemIndex.satuan
            this.rowPembelian[indexpembelian].dataSatuan = ItemIndex.namasatuan
          } else {
            this.rowPembelian[indexpembelian].dataPrice = this.formatUang(ItemIndex.harga_pembelian)
            this.rowPembelian[indexpembelian].dataJumlahSbPajak = ItemIndex.harga_pembelian
            this.rowPembelian[indexpembelian].dataUnit = ItemIndex.satuan_pembelian
            this.rowPembelian[indexpembelian].dataSatuan = ItemIndex.namasatuanpembelian
          }
          this.updateJumlah (indexpembelian)
        }
      }
    },
    pilihPajak(indexpembelian) {
      if (this.rowPembelian[indexpembelian].changePajak) {
        this.updateJumlah(indexpembelian)
        this.rowPembelian[indexpembelian].changePajak = false
      }
    },
    addPembelian () {
      this.changePembelian = true
      let new_row = document.createElement('div')
      new_row.className = "vx-row flex"
      this.rowPembelian.push({
        dataTaxonomy: 0,
        slugTaxonomy: '',
        changeTaxonomy: false,
        barangAddDisabled: false,
        dataBarangList: [],
        dataBarang: 0,
        changeBarang: false,
        dataBarangNama: null,
        dataUnit : 0,
        dataPrice: 0,
        dataQuantity : 1,
        dataPajak: 0,
        changePajak: false,
        dataJumlahSbPajak: 0,
        dataJumlahPajak: 0,
        dataJumlah : 0
      });
    },
    deletePembelian (indexpembelian) {
      if (this.rowPembelian.length > 1) {
        this.rowPembelian.splice(indexpembelian, 1)
        this.eventSubTotal()
        this.updatePotongan()
        this.updateUangMuka ()
      } else {
        this.$vs.notify({
          text: 'Update',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    updateJumlah (indexpembelian) {
      if (this.disabled == false) {
        if (this.rowPembelian[indexpembelian].dataPrice != 0) {
          let price = this.rowPembelian[indexpembelian].dataPrice.split('.').join("")
          this.rowPembelian[indexpembelian].dataJumlahSbPajak = price * this.rowPembelian[indexpembelian].dataQuantity
          if (this.rowPembelian[indexpembelian].dataPajak != 0) {
            let ItemPajak = this.listPajak.find((pajak) => pajak.id == this.rowPembelian[indexpembelian].dataPajak)
            this.rowPembelian[indexpembelian].dataJumlahPajak = ItemPajak.nilai * this.rowPembelian[indexpembelian].dataJumlahSbPajak / 100
          } else {
            this.rowPembelian[indexpembelian].dataJumlahPajak = 0
          }

          this.rowPembelian[indexpembelian].dataJumlah = parseFloat(this.rowPembelian[indexpembelian].dataJumlahSbPajak) + parseFloat(this.rowPembelian[indexpembelian].dataJumlahPajak)
          this.eventSubTotal()
          this.updatePotongan()
          this.updateUangMuka()
        }
      }
    },
    eventSubTotal () {
      //if (this.disabled == false) {
        this.dataSubTotal = 0
        this.dataPajakTotal = 0
        this.dataTotalPU = 0
        for(var i = 0, len = this.rowPembelian.length; i < len; i++) {
          this.dataSubTotal += parseFloat(this.rowPembelian[i].dataJumlahSbPajak);
          this.dataPajakTotal += parseFloat(this.rowPembelian[i].dataJumlahPajak);
        }
        this.dataTotalPU = parseFloat(this.dataSubTotal) + parseFloat(this.dataPajakTotal)
        this.eventTotal()
      //}
    },
    updatePotongan () {
      if (this.disabled == false) {
        if (this.dataPotonganPersen != 0 && this.dataPotonganPersen < 100) {
          this.dataPotonganJumlah = this.dataTotalPU * this.dataPotonganPersen / 100
          this.dataPotonganJumlah = this.formatUang(this.dataPotonganJumlah)
          this.eventTotal()
        }
      }
    },
    updatePotonganJumlah () {
      if (this.disabled == false) {
        if (this.dataPotonganPersen != 0 && this.dataPotonganPersen < 100) {
          this.eventTotal()
        }
      }
    },
    changePilihPembayaran () {
      this.changePembayaran = true
    },
    changePilihAkunKas () {
      this.changeAkunKas = true
    },
    updateUangMuka () {
      if (this.changeAkunKas) {
        if (this.dataAkunKas != 0) {
          if (this.dataPembayaranJumlah != 0 && this.dataPembayaranJumlah != null && this.dataPembayaranJumlah < this.dataTotal && this.dataPembayaran === 'uang-muka-pembelian') {
            this.eventTotal()
          }
          /* else {
            this.$vs.notify({
              text: 'Masukkan angka yang benar',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } */
        } else {
          this.$vs.notify({
            text: 'Pilih Kas',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      } 
    },
    eventTotal () {
      if (this.disabled == false) {
        if (this.dataTotalPU > 0) {
          let biayakirim = 0
          if (this.dataBiayaKirim != 0) {
            biayakirim = this.dataBiayaKirim.split('.').join("")
          } else {
            biayakirim = this.dataBiayaKirim
          }
          let biayalainlain = 0
          if (this.dataBiayaLainlain != 0) {
            biayalainlain = this.dataBiayaLainlain.split('.').join("")
          } else {
            biayalainlain = this.dataBiayaLainlain
          }
          let pembayaran = 0
          if (this.dataPembayaranJumlah != 0) {
            pembayaran = this.dataPembayaranJumlah.split('.').join("")
          } else {
            pembayaran = this.dataPembayaranJumlah
          }
          
          let potonganjumlah = 0
          if (this.dataPotonganJumlah != 0) {
            potonganjumlah = this.dataPotonganJumlah.split('.').join("")
          } else {
            potonganjumlah = this.dataPotonganJumlah
          }
          
          this.dataTotal = this.dataTotalPU + parseFloat(biayakirim) + parseFloat(biayalainlain) - potonganjumlah - pembayaran
        }
      }
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.Attachment = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
    },
    closeKatUpdateView() {
      this.$emit('closeUpdate')
      this.$vs.notify({
        title: 'Error',
        text: 'Pilihan tidak valid',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    },
    closeUpdateView() {
      this.initValues()
      this.$emit('closeUpdate')
      this.initValues()
    },
    // MOBILE
      cameraTakePicture() { 
      if (themeConfig.mobileMode == true) {
          navigator.camera.getPicture(this.cameraSuccess, this.cameraFail,this.opti);
      }
      },
      cameraFail(message) { 
      this.$vs.notify({
          color : 'danger',
          text  : message,
      })
      }, 
      cameraSuccess (imageData) {
        this.Attachment = "data:image/jpeg;base64," + imageData;
      },
      mapOnePosition(position) {
        this.dataLatitude = position.coords.latitude
        this.dataLongitude = position.coords.longitude
      }, 
      mapOneError(error) {
        this.$vs.notify({
            color : 'danger',
            title : error.code,
            text  : error.message,
        })
      },
      loadLatLng(lopembeliani){
        if (lopembeliani) {
            if (this.dataLatitude != lopembeliani.coords.latitude 
            || this.dataLongitude != lopembeliani.coords.longitude) {
            this.dataLatitude = lopembeliani.coords.latitude
            this.dataLongitude = lopembeliani.coords.longitude
            }
        } else {
            this.$vs.notify({
            color : 'danger',
            title : 'Aktifkan GPS Lopembeliani anda',
            })
        }
      },
      mapError(error) {
        this.$vs.notify({
            color : 'danger',
            title : error.code,
            text  : error.message,
        })
      }
  }
}
</script>
<style lang="scss" scoped>
  .tranksaksi-view-sidebar {
    ::v-deep .vs-sidebar {
      .jumlah {
        text-align: right;
        .vs-con-input {
          .vs-input--input {
            text-align: right;
          }
        }
      }
    }
  }
</style>